export default __webpack_public_path__ + "static/media/Gopal.16c3b8e4.svg";